module.exports = "../images/beach-access.svg?v=74e59ac";